import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/strata';

const namespace = 'ANALYSIS';

export const FETCH_STRATA_CONFIGURATIONS = createRequestTypes(
  `${namespace}/FETCH_STRATA_CONFIGURATION`,
);

export const fetchStrataConfigurations = makeApiActionCreatorV3(
  api.fetchStrataConfigurations,
  FETCH_STRATA_CONFIGURATIONS[START],
  FETCH_STRATA_CONFIGURATIONS[SUCCESS],
  FETCH_STRATA_CONFIGURATIONS[ERROR],
);

export const FETCH_STRATA_CONFIGURATION_BY_TAXING_UNIT = createRequestTypes(
  `${namespace}/FETCH_STRATA_CONFIGURATION_BY_TAXING_UNIT`,
);

export const fetchStrataConfigurationByTaxingUnit = makeApiActionCreatorV3(
  api.fetchStrataConfigurationByTaxingUnit,
  FETCH_STRATA_CONFIGURATION_BY_TAXING_UNIT[START],
  FETCH_STRATA_CONFIGURATION_BY_TAXING_UNIT[SUCCESS],
  FETCH_STRATA_CONFIGURATION_BY_TAXING_UNIT[ERROR],
);

export const FETCH_STRATA_STATE_CODES = createRequestTypes(
  `${namespace}/FETCH_STRATA_STATE_CODES`,
);

export const fetchStrataStateCodes = makeApiActionCreatorV3(
  api.fetchStrataStateCodes,
  FETCH_STRATA_STATE_CODES[START],
  FETCH_STRATA_STATE_CODES[SUCCESS],
  FETCH_STRATA_STATE_CODES[ERROR],
);

export const INSERT_STRATA_CONFIGURATION = createRequestTypes(
  `${namespace}/INSERT_STRATA_CONFIGURATION`,
);

export const insertStrataConfiguration = makeApiActionCreatorV3(
  api.insertStrataConfiguration,
  INSERT_STRATA_CONFIGURATION[START],
  INSERT_STRATA_CONFIGURATION[SUCCESS],
  INSERT_STRATA_CONFIGURATION[ERROR],
);

export const UPDATE_STRATA_CONFIGURATION = createRequestTypes(
  `${namespace}/UPDATE_STRATA_CONFIGURATION`,
);

export const updateStrataConfiguration = makeApiActionCreatorV3(
  api.updateStrataConfiguration,
  UPDATE_STRATA_CONFIGURATION[START],
  UPDATE_STRATA_CONFIGURATION[SUCCESS],
  UPDATE_STRATA_CONFIGURATION[ERROR],
);

export const DELETE_STRATA_CONFIGURATION = createRequestTypes(
  `${namespace}/DELETE_STRATA_CONFIGURATION`,
);

export const deleteStrataConfiguration = makeApiActionCreatorV3(
  api.deleteStrataConfiguration,
  DELETE_STRATA_CONFIGURATION[START],
  DELETE_STRATA_CONFIGURATION[SUCCESS],
  DELETE_STRATA_CONFIGURATION[ERROR],
);

export const FETCH_STRATA_RUNS = createRequestTypes(
  `${namespace}/FETCH_STRATA_RUNS`,
);

export const fetchStrataRuns = makeApiActionCreatorV3(
  api.fetchStrataRuns,
  FETCH_STRATA_RUNS[START],
  FETCH_STRATA_RUNS[SUCCESS],
  FETCH_STRATA_RUNS[ERROR],
);

export const DELETE_STRATA_RUN = createRequestTypes(
  `${namespace}/DELETE_STRATA_RUN`,
);

export const deleteStrataRun = makeApiActionCreatorV3(
  api.deleteStrataRun,
  DELETE_STRATA_RUN[START],
  DELETE_STRATA_RUN[SUCCESS],
  DELETE_STRATA_RUN[ERROR],
);

export const FETCH_STRATA_TAXING_UNITS = createRequestTypes(
  `${namespace}/FETCH_STRATA_TAXING_UNITS`,
);

export const fetchStrataTaxingUnits = makeApiActionCreatorV3(
  api.fetchStrataTaxingUnits,
  FETCH_STRATA_TAXING_UNITS[START],
  FETCH_STRATA_TAXING_UNITS[SUCCESS],
  FETCH_STRATA_TAXING_UNITS[ERROR],
);

export const CREATE_STRATA_RUN = createRequestTypes(
  `${namespace}/CREATE_STRATA_RUN`,
);

export const createStrataRun = makeApiActionCreatorV3(
  api.createStrataRun,
  CREATE_STRATA_RUN[START],
  CREATE_STRATA_RUN[SUCCESS],
  CREATE_STRATA_RUN[ERROR],
);

export const FETCH_STRATA_RUN_TAXING_UNITS = createRequestTypes(
  `${namespace}/FETCH_STRATA_RUN_TAXING_UNITS`,
);

export const fetchStrataRunTaxingUnits = makeApiActionCreatorV3(
  api.fetchStrataRunTaxingUnits,
  FETCH_STRATA_RUN_TAXING_UNITS[START],
  FETCH_STRATA_RUN_TAXING_UNITS[SUCCESS],
  FETCH_STRATA_RUN_TAXING_UNITS[ERROR],
);

export const FETCH_STRATA_RUN_TAXING_UNIT_DETAIL = createRequestTypes(
  `${namespace}/FETCH_STRATA_RUN_TAXING_UNIT_DETAIL`,
);

export const fetchStrataRunTaxingUnitDetail = makeApiActionCreatorV3(
  api.fetchStrataRunTaxingUnitDetail,
  FETCH_STRATA_RUN_TAXING_UNIT_DETAIL[START],
  FETCH_STRATA_RUN_TAXING_UNIT_DETAIL[SUCCESS],
  FETCH_STRATA_RUN_TAXING_UNIT_DETAIL[ERROR],
);

export const FETCH_STRATA_RUN_CATEGORY_DETAIL = createRequestTypes(
  `${namespace}/FETCH_STRATA_RUN_CATEGORY_DETAIL`,
);

export const fetchStrataRunCategoryDetail = makeApiActionCreatorV3(
  api.fetchStrataRunCategoryDetail,
  FETCH_STRATA_RUN_CATEGORY_DETAIL[START],
  FETCH_STRATA_RUN_CATEGORY_DETAIL[SUCCESS],
  FETCH_STRATA_RUN_CATEGORY_DETAIL[ERROR],
);
